<template>
  <div>
    <div class="actions">
      <el-button
        class="main-button"
        size="small"
        v-if="isSuperAdmin"
        @click="summaryDialogVisible = !summaryDialogVisible"
        >邀请记录</el-button
      >
      <el-button
        class="main-button"
        type="primary"
        size="small"
        v-if="isSuperAdmin"
        @click="inviteDialogVisible = !inviteDialogVisible"
        >邀请注册</el-button
      >
    </div>
    <div class="mt-10">
      <UsersListAdminTable :users="users"></UsersListAdminTable>
    </div>
    <el-dialog v-if="inviteDialogVisible" :visible.sync="inviteDialogVisible">
      <UserRegisterInvite></UserRegisterInvite>
    </el-dialog>
    <el-dialog
      top="8vh"
      v-if="summaryDialogVisible"
      :visible.sync="summaryDialogVisible"
    >
      <UserInviteSummary :invites="summaryInvites"></UserInviteSummary>
    </el-dialog>
  </div>
</template>

<script>
import UsersListAdminTable from "@/components/UsersListAdminTable";
import UserRegisterInvite from "@/components/UserRegisterInvite";
import UserInviteSummary from "@/components/UserInviteSummary";
import { ClaimRolePermissionMixin, OopsErrorELMessage } from "@/mixins";
export default {
  name: "Users",
  mixins: [ClaimRolePermissionMixin, OopsErrorELMessage],
  components: { UsersListAdminTable, UserRegisterInvite, UserInviteSummary },
  data() {
    return {
      users: [],
      inviteDialogVisible: false,
      summaryDialogVisible: false,
      summaryInvites: []
    };
  },
  beforeCreate() {
    this.$http.get("/api/v1/users").then(resp => {
      this.users = resp.data;
    });
  },
  watch: {
    summaryDialogVisible(v) {
      if (!v) {
        this.summaryInvites = [];
      } else {
        this.getInvites();
      }
    }
  },
  methods: {
    getInvites() {
      this.$http
        .get("/api/v1/users/invites")
        .then(resp => {
          this.summaryInvites = resp.data;
        })
        .catch(() => this.oopsError());
    }
  }
};
</script>
